<template>
  <div class="m-guide">
    <section class="zero">
      <img :src="require('@/assets/mobile/guide00.png')"/>
      <div class="desc">
        <p>充电操作指引</p>
        <p>操作简便 安全高效</p>
      </div>
    </section>
    <section class="one">
      <img :src="require('@/assets/mobile/guide01.png')"/>
    </section>
    <section class="two">
      <img :src="require('@/assets/mobile/guide02.png')"/>
    </section>
    <section class="three">
      <img :src="require('@/assets/mobile/guide03.png')"/>
    </section>
    <section class="four">
      <img :src="require('@/assets/mobile/guide04.png')"/>
    </section>
    <section class="five">
      <img :src="require('@/assets/mobile/guide05.png')"/>
    </section>
  </div>
</template>
<script>
export default {
  name: 'guide'
}
</script>
<style lang="less">
.m-guide{
  img{
    width: 100%;
    height: 100%;
  }
  section{
    width: 100%;
    position: relative;
    &.zero{
      height: 7.82rem;
      .desc{
        width: 100%;
        position: absolute;
        top: .3rem;
        p{
          color: white;
          &:first-child{
            font-size: .6rem;
            line-height: .8rem;
            margin-bottom: .1rem;
          }
          &:last-child{
            // opacity: .;
            font-size: .32rem;
            line-height: .4rem;
          }
        }
      }
    }
    &.one{
      height: 6.34rem;
    }
    &.two{
      height: 5.94rem;
    }
    &.three{
      height: 6.36rem;
    }
    &.four{
      height: 6.27rem;
    }
    &.five{
      height: 6.7rem;
      margin-bottom: .5rem;
    }
  }
}
</style>
